<template lang="html">
  <div class="image-gallery col-12" v-if="treatment_plan && treatment_plan.TreatPlanNum && custom_claims && custom_claims.customerId && custom_claims.authorized_location && pat_num">
    
    <div v-if="treatPlanMeta && sortedImages" class="row justify-content-center">
      <div class="col-12 col-md-6 col-xl-4" v-for="(imgMeta,imgId) in sortedImages" :key="imgId">
        <div class="img-container">
          <button class="btn img-crop" v-if="images[imgId]" :style="{'background-image': 'url(' + images[imgId] + ')'}" style="background-size: cover;" @click="activePhoto=imgId"></button>
            <!-- <img v-if="images[imgId]" :src="images[imgId]" alt="photo" class="img-fluid" width="100" height="100"> -->
            <div v-if="(!editingImageId || editingImageId!==imgId) && (!deletingImageId || deletingImageId!=imgId)" class="img-footer d-flex">
              <button v-if="allowPhotoControls" @click="editCaption(imgId)" class="btn btn-caption flex-grow-1">
                <span v-if="!treatPlanMeta.images[imgId].caption" class="color-dim"><em>click to add caption</em></span>
                <span v-if="treatPlanMeta.images[imgId].caption" class="caption">{{ treatPlanMeta.images[imgId].caption }}</span>
              </button>
              <button v-if="allowPhotoControls" @click="deletingImageId=imgId" class="btn btn-icon btn-cancel btn-icon-tall"><i class="fas color-dim fa-times"></i></button>
              <div v-if="!allowPhotoControls && treatPlanMeta.images[imgId].caption" class="caption flex-grow-1 text-center">{{ treatPlanMeta.images[imgId].caption }}</div>
            </div>
          
          <div v-if="allowPhotoControls && editingImageId==imgId" class="img-footer img-footer-edit">
            <input @keyup.enter="updateCaption(imgId)" ref="captionInput" type="text" placeholder="type caption text" v-model="newCaption" class="form-control form-control-caption">
            <div class="footer-container-btns d-flex justify-content-between">
              <button @click="updateCaption(imgId)" class="btn btn-link btn-link-save"><strong>Save Edits</strong></button>
              <button @click="cancelEditCaption" class="btn btn-link btn-link-cancel">Cancel</button>
            </div>
          </div>

          <div v-if="allowPhotoControls && deletingImageId==imgId" class="img-footer img-footer-delete d-flex">
            <button @click="deleteImage(imgId)" class="btn btn-delete flex-grow-1">
              <span>Click Here Again to Delete Photo</span><br>
              <small><em>can't be undone</em></small>
            </button>
            <button @click="deletingImageId=null" class="btn btn-icon btn-cancel btn-icon-tall"><i class="fas fa-ban"></i></button>
          </div>
        </div> <!-- /.img-container -->
      </div> <!-- /.col -->
    </div> <!-- /.row -->

    <div v-if="allowPhotoControls" class="banner-upload text-center">
      <hr v-if="!includeImage">
      <button v-if="!includeImage" @click="includeImage=true" class="btn btn-app btn-icon-left btn-lg btn-dim"><i class="fas fa-fw fa-plus-square"></i>Upload Photo</button>
      <div v-if="includeImage" class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><i class="far fa-image"></i></div>
        </div>
        <input @change="previewFiles" class="form-control" placeholder="Select a file" type="file" accept="image/*" multiple />
        <button class="btn btn-bare-cancel" @click="includeImage=false">cancel</button>
      </div>
      <list-errors :errors="errors"></list-errors>
      <p v-if="uploadingImages && uploadingImages.length" class="uploading-images sm text-center snug"><i class="far fa-fw fa-pulse fa-spinner"></i> <em>uploading images, please do not close or refresh page</em></p>
    </div>

    <div v-if="activePhoto" class="modal modal-app" tabindex="-1">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-body text-center">
            <button class="btn btn-icon btn-close" @click="activePhoto=null"><i class="fas fa-times"></i></button>
            <div class="photo-scroll">
              <img v-if="images[activePhoto]" :src="images[activePhoto]" alt="photo" class="img-fluid">
              <span v-if="!images[activePhoto]">error: couldn't find photo</span>
            </div>
            <div class="modal-caption-container">
              <p v-if="treatPlanMeta.images[activePhoto].caption"><span class="caption">{{ treatPlanMeta.images[activePhoto].caption }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activePhoto" class="modal-backdrop"></div>

  </div>
</template>

<script>
import Vue from 'vue'
import Firebase from 'firebase/compat/app'
import {mapGetters} from 'vuex'
import ListErrors from '../components/ListErrors.vue'

export default {
  components: {
    ListErrors,
  },
  data () {
    return {
      errors: [],
      uploadErrors: [],
      images: {},
      treatPlanMeta: null,
      editingImageId: null,
      deletingImageId: null,
      newCaption: null,
      includeImage: false,
      activePhoto: null,
      uploadingImages: [],
    }
  },
  computed: {
    ...mapGetters(['custom_claims', 'treatment_plan', 'pat_num', 'pat_name']),
    sortedImages() {
      if(this.treatPlanMeta && this.treatPlanMeta.images) {
        let imageArr = Object.entries(this.treatPlanMeta.images);
        // sort by id - doesn't work great if uploaded as a batch
        imageArr.sort((a,b) => a[0] - b[0]);
        return Object.fromEntries(imageArr);
      }
      return null;
    },
    allowPhotoControls() {
      // return true; // testing
      // if the route matches certain names, allow photo controls
      const allowedRouteNames = ["viewPlan"];
      if(allowedRouteNames.includes(this.$route.name)) {
        return true;
      }
      return false;
    }
  },

  watch: {
    treatment_plan() {
      if(this.treatment_plan) {
        this.loadTpMeta();
      }
    },
    treatPlanMeta() {
      if(this.treatPlanMeta && this.treatPlanMeta.images &&  Object.keys(this.treatPlanMeta.images).length) {
        // if(this.$route.name == 'ViewPlan') {
          // console.log('load photos for printing');
          Object.keys(this.treatPlanMeta.images).forEach(imgId => this.loadPhoto(imgId,this.treatPlanMeta.images[imgId]));
        // } else {
        //   Object.keys(this.treatPlanMeta.images).forEach(imgId => {
        //     // default to path, override with compressed if it exists
        //     let storagePath = this.treatPlanMeta.images[imgId].path;
        //     if(this.treatPlanMeta.images[imgId].path_compressed) {
        //       storagePath = this.treatPlanMeta.images[imgId].path_compressed;
        //     }
        //     this.$set(this.images, imgId, storagePath)
        //   });
        // }
        
      }
    },
  },
  methods: {
    editCaption(imgId) {
      if(imgId) {
        this.editingImageId = imgId;
        this.newCaption = null;
        if(this.treatPlanMeta && this.treatPlanMeta.images && this.treatPlanMeta.images[imgId] && this.treatPlanMeta.images[imgId].caption) {
          this.newCaption = this.treatPlanMeta.images[imgId].caption;
        }
        this.$nextTick(() => {
          // since ref is in a loop, must treat it like there are more than 1
          this.$refs['captionInput'][0].focus();
        });
      }
    },
    cancelEditCaption() {
      this.editingImageId = null;
      this.newCaption = null;
    },
    updateCaption(imgId) {
      this.errors = [];
      // validate
      if(!imgId) {
        this.errors.push('image error, please reload the page and try again');
      }
      if(!this.newCaption || !this.newCaption.trim().length) {
          // console.log(this.messageText.trim().length)
          this.errors.push("Caption can't be blank.")
        }
      if(this.errors && this.errors.length) {
        return;
      }
      // tpMeta doc to include new caption text
      // save file to metadata
      let metaRef = Vue.firestore.doc(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/treatment_plans/${this.treatment_plan.TreatPlanNum}`);
      // meta must exist to have an image, so just update
      return metaRef.update({
        [`images.${imgId}.caption`]: this.newCaption,
      })
      .then(() => {
        this.editingImageId = null;
      })
      .catch(err => {
        console.log(err);
        this.errors.push(err.message);
      });
    },
    uploadImage(img) {
      // console.log(img);
      if(!img || !img.name || !this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.treatment_plan || !this.treatment_plan.TreatPlanNum) {
        console.log("cannot upload image, missing data");
        return;
      }
      let filenameSC = img.name.toLowerCase();
      console.log({filenameSC});
      if(this.includeImage && (filenameSC.includes('.jpg') || filenameSC.includes('.jpeg') || filenameSC.includes('.png') || filenameSC.includes('.gif') || filenameSC.includes('.webp') || filenameSC.includes('.avif') || filenameSC.includes('.tiff')) ) {
        const regex = /(?:\.([^.]+))?$/;
        // index 1 will return extension with no dot
        const fileExtension = regex.exec(img.name)[1];
        // const timestamp = Date.now();
        // const id = window.crypto.randomUUID(); // only works on localhost && https, not on local ip testing server
        // via https://stackoverflow.com/a/44078785/2913914
        const id = Date.now().toString(36) + Math.random().toString(36).substring(2);
        const newFileName = `${this.treatment_plan.TreatPlanNum}_${id}.${fileExtension}`;
        // add to list of uploading images
        this.uploadingImages.push(newFileName);
        // upload file
        const storagePath = `/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/treatment_plans/${this.treatment_plan.TreatPlanNum}/${newFileName}`;
        console.log(storagePath);
        let uploadRef = Vue.storage.ref().child(storagePath);
        const contType = `image/${fileExtension}`;
        uploadRef.put(img, {contentType: contType})
          .then((success) => {
            if(success) {
              // save file to metadata
              let metaRef = Vue.firestore.doc(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/treatment_plans/${this.treatment_plan.TreatPlanNum}`);
              // if meta exists, update it
              if(this.treatPlanMeta) {
                return metaRef.update({
                  [`images.${this.treatment_plan.TreatPlanNum}_${id}`]: {
                    path: storagePath,
                    // caption: null,
                    // path_compressed: null,
                  }
                });
              } else {
                // else, set it
                return metaRef.set({
                  images: {
                    [`${this.treatment_plan.TreatPlanNum}_${id}`]: {
                      path: storagePath,
                      // caption: null,
                      // path_compressed: null,
                    }
                  }
                });
              }
            } else {
              return false;
            }
          })
          .then(() => {
            console.log('image saved successfully');
            // remove from list of uploading images
            const imgInd = this.uploadingImages.findIndex(im => img == newFileName);
            this.uploadingImages.splice(imgInd,1);
            // this.loading = false;
          })
          .catch(err => console.log(err));
      } else {
        console.log("cannot upload image, incrrect file type");
      }
    },
    previewFiles(event) {
      // console.log('event.target.files',event.target.files);
      if(event && event.target && event.target.files && event.target.files.length) {
        let fileList = [...event.target.files];
        fileList.forEach(file => this.uploadImage(file));
        this.includeImage = null;
      }
    },

    deleteImage(imgId) {
      if(!imgId || !this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.treatment_plan || !this.treatment_plan.TreatPlanNum || !this.treatPlanMeta || !this.treatPlanMeta.images || !this.treatPlanMeta.images[imgId] || !this.treatPlanMeta.images[imgId].path) {
        console.log("cannot delete image, missing data");
        return;
      }
      // delete from storage
      let deleteRef = Vue.storage.ref().child(this.treatPlanMeta.images[imgId].path);
      return deleteRef.delete()
        // also delete path_compressed
        .then(() => {
          // if compressed exists, delete it
          if(this.treatPlanMeta.images[imgId].path_compressed) {
            return Vue.storage.ref().child(this.treatPlanMeta.images[imgId].path_compressed).delete();
          }
          return true;
        })
        // then delete from meta doc
        .then(() => {
          let metaRef = Vue.firestore.doc(`/customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/treatment_plans/${this.treatment_plan.TreatPlanNum}`);
          // meta must exist to have an image, so just update
          return metaRef.update({
            [`images.${imgId}`]: Firebase.firestore.FieldValue.delete(),
          });
        })
        .then(() => {
          this.deletingImageId = null;
        })
        .catch(err => {
          console.log(err);
        });
    },
    loadTpMeta() {
      // exit if missing data
      if(!this.treatment_plan || !this.treatment_plan.TreatPlanNum || !this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.pat_num) {
        return;
      }
      Vue.firestore
        .doc(`customers/${this.custom_claims.customerId}/locations/${this.custom_claims.authorized_location}/treatment_plans/${this.treatment_plan.TreatPlanNum}`)
        .onSnapshot(metaSnap => {
          if(metaSnap.exists) {
            this.treatPlanMeta = metaSnap.data();
            return true;
          }
          console.log('no treatment plan meta data found');
        })
        // .catch(err => {
        //   console.log(err);
        //   this.errors.push(err.message);
        // })
    },
    // modified from ViewPlan.vue
    loadPhoto(photoId, photoObj) {
      if(!photoId || !photoObj || (!photoObj.path && !photoObj.path_compressed)) {
        return;
      }
      // default to path, override with compressed if it exists
      let storagePath = photoObj.path;
      if(photoObj.path_compressed) {
        storagePath = photoObj.path_compressed;
      }
      // console.log(`loading photo ${photoId} at ${storagePath}`);
      Vue.storage.ref().child(storagePath).getDownloadURL()
        .then((result) => {
          // only show if correct filetype
          if(result.includes('.jpg') || result.includes('.jpeg') || result.includes('.png') || result.includes('.gif')) {
            return fetch(result);
          }
          console.error('image url not found');
          return false;
        })
        .then(response => {
          if(response) {
            return response.blob();
          }
          console.error("couldn't fetch image");
          return false;
        })
        .then(blob => {
          if(blob) {
            this.$set(this.images, photoId, URL.createObjectURL(blob));
            return true;
          }
          console.log("couldn't create blob")
          return false;
        })
        .catch(e => console.log(e));
    },
  },
  mounted() {
    if(this.treatment_plan) {
      this.loadTpMeta();
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/less/variables.less";

.img-container {
  border: 1px solid @dark-color;
  margin-bottom: 30px;
  background-color: @color-blue;
}
.btn.img-crop {
  display: block;
  width: 100%;
  height: 350px;
  border: 1px solid @light-color;
  

  &:hover {
    opacity: 0.2;
  }
}
.img-footer {
  border-top: 1px solid @dark-color;
  background-color: @light-color;
}
.img-footer-delete {
  .btn-cancel {
    color: @color-salmon !important;
  }
}
.img-footer-edit {
  padding-bottom: 10px;
}
.footer-container-btns {
  padding: 0 10px;
}
.form-control-caption {
  border: none;
}
.banner-upload {
  position: relative;
  margin: 0 0 50px 0;
  padding: 62px 0 30px;

  hr {
    border-top-color: @dim-color;
    margin: 0 0 -32.5px;
  }
  .btn {
    position: relative;
    z-index: 10;
  }
}
// buttons
.btn-caption,
.caption {
  font-size: 14px;
  line-height: 18px;
  padding: 15px 15px 17px;
}
.btn-icon-tall {
  border-left: 1px solid @dark-color !important;
  padding-right: 10px;
  padding-left: 10px;
  // height: 100%;
  min-height: 100%;
}
.btn-link {
  font-size: 14px;
  line-height: 1em;
  padding: 5px;
  text-decoration: underline;
}
.btn-link-save:hover {
  color: @color-green;
}
.btn-link-cancel:hover {
  color: @color-salmon;
}
.btn-dim {
  color: #999;
  background-color: @light-color;
  border: 1px solid @dim-color !important;

  &:hover {
    color: @color-green;
    background-color: @dark-color !important;
    border-color: @color-green;
  }
}
.btn-delete {
  background-color: @color-salmon;
  display: block;
  padding: 20px;
  width: 100%;
  height: 100%;

  span {
    font-size: 16px;
    line-height: 20px;
    font-weight: 700;
    text-decoration: underline;
  }
  small {
    font-size: 14px !important;
  }
}
.uploading-images {
  margin-top: 10px;
}
// modal overrides
.modal-body .btn-close {
  // right: 35px;
  background-color: fadeout(@light-color,50%);
}
.modal-caption-container {
  // background-color: @light-color;
  padding: 20px;

  p {
    margin: 0;
  }
}
</style>
